export default __webpack_public_path__ + "static/logo-prestashop2-b4de5c18fd41dc669e60373c9f51b4d8.svg";